export default "__VITE_ASSET__571dfb52__"